<div class="context-menu-panel" *ngIf="visibility">
    <div class="close-btn d-flex flex-column align-items-end" (click)="close()"><img src="assets/Inbox/close_icon_u73.svg" alt=""></div>
    <p-slideMenu styleClass='mobile-context-menu' [backLabel]='currentItem' [model]="items"></p-slideMenu>
</div>